import type {
  CmsPolicySummaryDeliveryNote,
  CmsPolicySummaryDeliveryNoteStatus,
} from '$/(cms)/_modules/cmsService/types/components';

/**
 * Pick the delivery note matching the resolved purchase status. A provider-
 * specific note (matched by carrier code) wins over the generic (provider-less)
 * entry, mirroring the HubSpot `<carrier>-manual-writing` selection (CMS-1794).
 * Shared by the Policy Summary Card (delivery note) and the Progress Stepper
 * (greeting), which reuse the same `base-component.delivery-note` component.
 */
export const pickDeliveryNoteHtml = (
  notes: CmsPolicySummaryDeliveryNote[],
  status: CmsPolicySummaryDeliveryNoteStatus,
  carrierCode: string | undefined,
): string | undefined => {
  const matching = notes.filter((note) => note.status === status);
  const byCarrier = carrierCode
    ? matching.find((note) => note.providerCarrierCode === carrierCode)
    : undefined;
  const generic = matching.find((note) => !note.providerCarrierCode);
  return (byCarrier ?? generic)?.note || undefined;
};
